import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';

import { CustomFormSubmission, CustomFormFieldSubmission } from '@core/objects/form';

import * as fromState from '@app/store/state/projects/custom-forms/projects-custom-forms.state';
import * as fromActions from '@app/store/state/projects//custom-forms/projects-custom-forms.actions';
import {  FieldSubmissionValueInterface } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';


@Injectable({
    providedIn: 'root'
})
export class ProjectsFormsService {

    constructor(private store: Store<fromState.ProjectsCustomFormsState>, private actions$: Actions) {}

    loadForms = (project: number) => this.store.dispatch(fromActions.LoadForms({project}));

    loadFormFieldSubmissions = (formId: string) => this.store.dispatch(fromActions.LoadFieldSubmissions({formId}));

    // selectors
    selectForms = (): Observable<CustomFormSubmission[]> => this.store.select(fromState.selectForms);

    selectFormFields = (id: string):  Observable<CustomFormFieldSubmission[]> => this.store.select(fromState.selectFields(id));

    selectFormFieldsPendingValues = (): Observable<boolean> => this.store.select(fromState.selectPendingFormFieldSubmissionValues);
    
    // selectError = (): Observable<any> => this.store.select(fromState.selectError);

    selectLoadingForms = (): Observable<boolean> => this.store.select(fromState.selectLoadingForms);
      
    selectLoadingFields = (formId: string): Observable<boolean> => this.store.select(fromState.selectLoadingFields(formId));
      
    selectErrorForms = (): Observable<HttpErrorResponse> => this.store.select(fromState.selectErrorForms);
    
    selectErrorFields = (formId: string): Observable<HttpErrorResponse> => this.store.select(fromState.selectErrorFields(formId));

    selectProject = (): Observable<number> => this.store.select(fromState.selectProject);
    

    // values
    setFieldValue = (formId: string,value: FieldSubmissionValueInterface) => this.store.dispatch( fromActions.SetFieldValue({formId, value}));

    submitFieldValues = (formId: string) => this.store.dispatch( fromActions.SubmitFieldsValues({formId}));

    selectFieldValues = (formId: string): Observable<FieldSubmissionValueInterface[]> => this.store.select(fromState.selectFormFieldSubmissionValues(formId));

    cleanFormErrors = () => this.store.dispatch( fromActions.ClearFormFailures());

    cleanFormFieldValues = () => this.store.dispatch( fromActions.ClearFormFieldValues());

    // event updates 
    updateProjectForms = (projectId: number, event: string) => this.store.dispatch( fromActions.UpdateForms({projectId, event}));
}
